import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import './contact.css'

const Contact = (props) => {
  // Contact information configuration
  const contactInfo = [
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" className="contact-icon10">
          <g fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M7.4 7H4.6a.6.6 0 0 0-.6.6v8.8a.6.6 0 0 0 .6.6h2.8a.6.6 0 0 0 .6-.6V7.6a.6.6 0 0 0-.6-.6m12 0h-2.8a.6.6 0 0 0-.6.6v8.8a.6.6 0 0 0 .6.6h2.8a.6.6 0 0 0 .6-.6V7.6a.6.6 0 0 0-.6-.6"></path>
            <path d="M1 14.4V9.6a.6.6 0 0 1 .6-.6h1.8a.6.6 0 0 1 .6.6v4.8a.6.6 0 0 1-.6.6H1.6a.6.6 0 0 1-.6-.6m22 0V9.6a.6.6 0 0 0-.6-.6h-1.8a.6.6 0 0 0-.6.6v4.8a.6.6 0 0 0 .6.6h1.8a.6.6 0 0 0 .6-.6M8 12h8"></path>
          </g>
        </svg>
      ),
      title: 'Gym Fit Elite',
      content: props.address1 ?? (
        <Fragment>
          <span className="contact-text19">Erbenova 2906, 470 01, Česká Lípa</span>
        </Fragment>
      ),
      className: 'contact-content2',
      infoClassName: 'contact-contact-info1'
    },
    {
      icon: (
        <svg viewBox="0 0 1024 1024" className="contact-icon14">
          <path d="M282 460q96 186 282 282l94-94q20-20 44-10 72 24 152 24 18 0 30 12t12 30v150q0 18-12 30t-30 12q-300 0-513-213t-213-513q0-18 12-30t30-12h150q18 0 30 12t12 30q0 80 24 152 8 26-10 44z"></path>
        </svg>
      ),
      title: 'Phone',
      content: props.phone1 ?? (
        <Fragment>
          <span className="contact-text21">+ 420 776 40 30 70</span>
        </Fragment>
      ),
      className: 'contact-content4',
      infoClassName: 'contact-contact-info2'
    },
    {
      icon: (
        <svg viewBox="0 0 1024 1024" className="contact-icon16">
          <path d="M854 342v-86l-342 214-342-214v86l342 212zM854 170q34 0 59 26t25 60v512q0 34-25 60t-59 26h-684q-34 0-59-26t-25-60v-512q0-34 25-60t59-26h684z"></path>
        </svg>
      ),
      title: 'E-mail',
      content: props.email1 ?? (
        <Fragment>
          <span className="contact-text22">info@fitelite.com</span>
        </Fragment>
      ),
      className: 'contact-content6',
      infoClassName: 'contact-contact-info3'
    }
  ]

  return (
    <div
      id={props.contactId}
      className={`contact-contact20 thq-section-padding ${props.rootClassName}`}
    >
      <div className="contact-max-width thq-section-max-width">
        {/* Section Title */}
        <div className="contact-section-title">
          <div className="contact-content1">
            <h2 className="contact-text10 thq-heading-2">
              {props.heading11 ?? (
                <Fragment>
                  <span className="contact-text29">Kontaktní údaje</span>
                </Fragment>
              )}
            </h2>
            <p className="contact-text11 thq-body-large">
              <span>Náš tým je připraven ti </span>
              <span className="contact-text13">pomoci</span>
              <span> s dosažením tvých fitness cílů</span>
            </p>
          </div>
        </div>

        {/* Contact Cards */}
        <div className="contact-row">
          {/* Gym Location, Phone, Email */}
          {contactInfo.map((item, index) => (
            <div key={index} className={item.className}>
              {item.icon}
              <div className={item.infoClassName}>
                <div className={`contact-content${index === 0 ? '3' : index === 1 ? '5' : '7'}`}>
                  <h3 className={`contact-text${index === 0 ? '15' : index === 1 ? '16' : '17'} thq-heading-3`}>
                    {item.title}
                  </h3>
                </div>
                <span className={index === 0 ? 'contact-address1 thq-body-small' : index === 1 ? 'contact-phone thq-body-small' : 'contact-email thq-body-small'}>
                  {item.content}
                </span>
              </div>
            </div>
          ))}

          {/* Company Information Card */}
          <div className="contact-content8">
            <svg width="32" height="32" viewBox="0 0 32 32" className="contact-icon18">
              <path
                d="M28 2H16a2 2 0 0 0-2 2v10H4a2 2 0 0 0-2 2v14h28V4a2 2 0 0 0-2-2M9 28v-7h4v7Zm19 0H15v-8a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v8H4V16h12V4h12Z"
                fill="currentColor"
              ></path>
              <path
                d="M18 8h2v2h-2zm6 0h2v2h-2zm-6 6h2v2h-2zm6 0h2v2h-2zm-6 6h2v2h-2zm6 0h2v2h-2z"
                fill="currentColor"
              ></path>
            </svg>
            <div className="contact-contact-info4">
              <div className="contact-content9">
                <h3 className="contact-text18 thq-heading-3">Fit elite, s.r.o.</h3>
              </div>
              <span className="contact-address2 thq-body-small">
                {props.email11 ?? (
                  <Fragment>
                    <span className="contact-text20">Rybná 716/24, 110 00, Praha 1</span>
                  </Fragment>
                )}
              </span>
              <span className="contact-jednatel thq-body-small">
                {props.email1111 ?? (
                  <Fragment>
                    <span className="contact-text23">
                      <span className="contact-text24">jednatel</span>
                      <span>: Tomáš Kulhánek</span>
                    </span>
                  </Fragment>
                )}
              </span>
              <span className="contact-ico thq-body-small">
                {props.email111 ?? (
                  <Fragment>
                    <span className="contact-text26">
                      <span className="contact-text27">IČ</span>
                      <span>: 21373132</span>
                    </span>
                  </Fragment>
                )}
              </span>
              <span className="contact-dic thq-body-small">
                {props.email1112 ?? (
                  <Fragment>
                    <span className="contact-text30">
                      <span className="contact-text31">DIČ</span>
                      <span>: CZ21373132</span>
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Contact.defaultProps = {
  address1: undefined,
  email11: undefined,
  phone1: undefined,
  email1: undefined,
  email1111: undefined,
  contactId: '',
  email111: undefined,
  heading11: undefined,
  email1112: undefined,
  rootClassName: '',
}

Contact.propTypes = {
  address1: PropTypes.element,
  email11: PropTypes.element,
  phone1: PropTypes.element,
  email1: PropTypes.element,
  email1111: PropTypes.element,
  contactId: PropTypes.string,
  email111: PropTypes.element,
  heading11: PropTypes.element,
  email1112: PropTypes.element,
  rootClassName: PropTypes.string,
}

export default Contact
